import React from "react";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { makeStyles } from "@material-ui/core/styles";
import DoneAllIcon from "@mui/icons-material/DoneAll";

const useStyles = makeStyles((theme) => ({
  toggleButtonGroup: {
    "&.MuiToggleButtonGroup-root": { display: "inline" },
  },
  toggleButton: {
    textTransform: "none",
    color: "rgba(245, 54, 137, .93)",
    padding: theme.spacing(1, 2),
    backgroundColor: "rgba(255, 239, 246, 1)",
    fontFamily: "Inter",
    border: "1px solid rgba(255, 223, 238, 1)",
    borderRight: "1px solid rgba(255, 223, 238, 1)",
    marginRight: 1,
    height: "42",

    "&.Mui-selected": {
      backgroundColor: "rgba(255, 223, 238, 1)",
      color: "rgba(245, 54, 137, .93)",
      "&:hover": {
        backgroundColor: "rgba(243, 179, 207, .8)",
      },
    },
    "&:hover": {
      backgroundColor: "rgba(243, 179, 207, .8)",
    },
  },
}));

export default function ToggleButtons({ config, tabIndex, onTabChange }) {
  const classes = useStyles();

  const handleAlignment = (event, newAlignment) => {
    onTabChange(newAlignment);
  };

  const calculateStyle = (idx) => {
    if (config.length === 1) {
      return { borderRadius: "24px 24px 24px 24px" };
    } else if (idx === 0) {
      return { borderRadius: "24px 0px 0px 24px" };
    } else if (idx + 1 === config.length) {
      return { borderRadius: "0px 24px 24px 0px" };
    }

    return {};
  };

  return (
    <ToggleButtonGroup
      value={tabIndex}
      exclusive
      onChange={handleAlignment}
      className={classes.toggleButtonGroup}
    >
      {config.map((element, _i) => (
        <ToggleButton
          key={_i}
          value={_i}
          className={classes.toggleButton}
          style={calculateStyle(_i)}
        >
          {tabIndex === _i && (
            <DoneAllIcon style={{ fontSize: 14, marginRight: 5 }} />
          )}
          {element.label}
        </ToggleButton>
      ))}
    </ToggleButtonGroup>
  );
}
